import React, { useEffect } from "react";
import BannerCarousel from "../components/BannerCarousel";
import FeaturedCollection from "../components/FeaturedCollection";
import KeyCustomersMarquee from "../components/KeyCustomersMarquee";
import BestSellers from "../components/BestSeller";
import Trending from "../components/Trending";
import Brands from "../components/Brands";

export default function Home() {
  useEffect(() => {
    document.title = "Tecniqa | HVAC Solutions";
  }, []);

  return (
    <>
      <BannerCarousel />
      <BestSellers />
      <Trending />
      <FeaturedCollection />
      <Brands />
      <KeyCustomersMarquee />
    </>
  );
}